'use client';
import * as React from 'react';
import { Homepage } from '@/shared/i18n';
import { HomePageScreen } from '@/page';
import { createEventBus } from '@/shared/utils';
import { DynamicPageEvents } from '../dynamic-page/events';
import { useServerAuth } from '@/auth';
import { useRouter } from 'next/navigation';

interface PageContainerProps {
  dict: Homepage;
  data: any;
}

export function HomePageContainer({ dict, data }: PageContainerProps) {
  const eventBus = createEventBus<DynamicPageEvents>('dynamic-page');
  const { user, hydrated } = useServerAuth();
  const router = useRouter();

  React.useEffect(() => {
    // logged customers should not be able to access landing page. Redirect to my-home
    if (hydrated && user) {
      router.push('/my-home');
    }
  }, [hydrated, user]);

  return <HomePageScreen dict={dict} key="homepage-screen" data={data} eventBus={eventBus} />;
}

export default HomePageContainer;
